import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";
import type { Location } from "@freightsimple/generated-dashboard-openapi-client/models/Location";
import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { locationsErrorMessageForBusinessName } from "./locationsErrorMessageForBusinessName";
import { locationsErrorMessageForHours } from "./locationsErrorMessageForHours";
import { locationsErrorMessageForLocationType } from "./locationsErrorMessageForLocationType";
import type { AddressErrors } from "./locationsErrorMessagesForAddress";
import { locationsErrorMessagesForAddress } from "./locationsErrorMessagesForAddress";
import { locationsErrorMessageForDistributionWarehouseBrand } from "./locationsErrorMessageForDistributionWarehouseBrand";

export interface LocationErrors {
  businessName: ErrorMessageType;
  address: AddressErrors;
  locationType: ErrorMessageType;
  hours: ErrorMessageType;
  distributionWarehouseBrand: ErrorMessageType;
}

export function locationsErrorMessagesForLocation(
  location: AddLocationLocationType | Location | PreQuoteLocation,
  checkHoursAreValidForAPickupToday: boolean,
): LocationErrors {
  const allowAfterHours = location.accessorials.includes(
    "SCHEDULING_AFTER_HOURS",
  );
  return {
    businessName: locationsErrorMessageForBusinessName(location.businessName),
    address: locationsErrorMessagesForAddress(location.address),
    locationType: locationsErrorMessageForLocationType(location.locationType),
    hours: locationsErrorMessageForHours(
      location.hours,
      allowAfterHours,
      checkHoursAreValidForAPickupToday,
    ),
    distributionWarehouseBrand:
      locationsErrorMessageForDistributionWarehouseBrand(
        location.locationType ?? LocationType.Warehouse,
        location.distributionWarehouseBrand,
      ),
  };
}
